export default __webpack_public_path__ + "static/New-York-24fb1444d833a597122ac1e6e7dd8856.webp";